import React from "react";
import HOC from "../../../components/HOC";
import AddRequestWarehouse from "../../../components/screen/centralWarehouse/request/AddRequestWarehouse";
import PageTemplate from "../../../components/common/particles.jsx/PageTemplate";
import { ThemeProvider } from "@mui/material";
import { theme } from "../../../components/constants/muiTheme";

const AddRequestAllocationPage = () => {
  return (
    <div className="">
      <PageTemplate
        header="New Request Allocation"
        mainComponent={
          <ThemeProvider theme={theme}>
            <AddRequestWarehouse type={4} />
          </ThemeProvider>
        }
        pageRole={37}
      />
    </div>
  );
};

export default HOC(AddRequestAllocationPage);
